import React from 'react';
import './style.scss';

const Footer = () => {
    return (
        <>
            <p>Cryptoverse © 2022 - All rights reserved.</p>
        </>
    );
};

export default Footer;